/**
 * Supported Adobe Sign agreement status(es) of interest.
 * @type {object}
 */
export const STATUS_AGREEMENT = {
	CANCELLED: 'CANCELLED',
	SIGNED: 'SIGNED',
};

/**
 * Supported Adobe Sign agreement asset status(es) to filter against during searching.
 * @type {object}
 */
export const STATUS_SEARCH = {
	ACCEPT_BEFORE_NOTARIZATION: 'ACCEPT_BEFORE_NOTARIZATION',
	ACCEPTED: 'ACCEPTED',
	ACTIVE: 'ACTIVE',
	APPROVED: 'APPROVED',
	ARCHIVED: 'ARCHIVED',
	AUTHORING: 'AUTHORING',
	CANCELLED: 'CANCELLED',
	DELIVERED: 'DELIVERED',
	DISABLED: 'DISABLED',
	EXPIRED: 'EXPIRED',
	FORM_FILLED: 'FORM_FILLED',
	OTHER: 'OTHER',
	OUT_FOR_ACCEPTANCE: 'OUT_FOR_ACCEPTANCE',
	OUT_FOR_APPROVAL: 'OUT_FOR_APPROVAL',
	OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
	OUT_FOR_FORM_FILLING: 'OUT_FOR_FORM_FILLING',
	OUT_FOR_SIGNATURE: 'OUT_FOR_SIGNATURE',
	REMOVED: 'REMOVED',
	SIGNED: 'SIGNED',
	/**
	 * Status not supported.
	 */
	// WAITING_FOR_AUTHORING: 'WAITING_FOR_AUTHORING',
	WAITING_FOR_MY_ACCEPTANCE: 'WAITING_FOR_MY_ACCEPTANCE',
	WAITING_FOR_MY_ACKNOWLEDGEMENT: 'WAITING_FOR_MY_ACKNOWLEDGEMENT',
	WAITING_FOR_MY_APPROVAL: 'WAITING_FOR_MY_APPROVAL',
	WAITING_FOR_MY_DELEGATION: 'WAITING_FOR_MY_DELEGATION',
	WAITING_FOR_MY_FORM_FILLING: 'WAITING_FOR_MY_FORM_FILLING',
	WAITING_FOR_MY_SIGNATURE: 'WAITING_FOR_MY_SIGNATURE',
	WAITING_FOR_NOTARIZATION: 'WAITING_FOR_NOTARIZATION',
	WAITING_FOR_PREFILL: 'WAITING_FOR_PREFILL',
}